import React from 'react';
import TrainingCenter from '../../components/TrainingCenter';

const TraingCenterModule = () => {
	return (
		<div>
			<TrainingCenter />
		</div>
	);
};

export default TraingCenterModule;
